"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTwoToneColor = setTwoToneColor;
exports.getTwoToneColor = getTwoToneColor;

var _iconsReact = _interopRequireDefault(require("@ant-design/icons-react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function setTwoToneColor(primaryColor) {
  return _iconsReact["default"].setTwoToneColors({
    primaryColor: primaryColor
  });
}

function getTwoToneColor() {
  var colors = _iconsReact["default"].getTwoToneColors();

  return colors.primaryColor;
}
//# sourceMappingURL=twoTonePrimaryColor.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/icon/twoTonePrimaryColor.js
// module id = 997
// module chunks = 0